var isTypedArray = {};
export {
  isTypedArray as __exports
};
//# sourceMappingURL=isTypedArray.js.map
